import onboardingClubImage from './assets/onboarding_club_530x288.svg';

export const STATUS_PRODUCT_APPROVED = 'APPROVED';

export { onboardingClubImage };
